import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Checkbox,
  Input,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "semantic-ui-react";
import "./styles.scss";
import { EligibilityLevel } from "@/services/bedrock";

export interface SegmentOption {
  id: number;
  level: EligibilityLevel;
  name: string;
}

interface OwnProps {
  open: boolean;
  level: EligibilityLevel;
  options: SegmentOption[];
  values: number[];
  onUpdate: (values: number[]) => void;
  onClose: () => void;
}

type Props = OwnProps;

const SegmentSelectionModalFC: React.FC<Props> = ({ open, onClose, values, options, onUpdate, level }) => {
  const [selectedIds, setSelectedIds] = useState<number[]>(values);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setSelectedIds(values);
  }, [values]);

  const filteredOptions = useMemo(() => {
    if (searchTerm) {
      return options.filter(o => o.name.toLowerCase().includes(searchTerm.toLowerCase()));
    } else return options;
  }, [searchTerm, options]);

  const title = useMemo(() => {
    switch (level) {
      case "STATE":
        return "Select States";
      case "BRANCH":
        return "Select Branches";
      case "REGION":
        return "Select Regions";
      case "PLAYER_ID":
        return "Select Players";
    }
  }, [level]);

  const selectAll = (selected: boolean) => {
    if (selected) {
      setSelectedIds(options.map(o => o.id));
    } else {
      setSelectedIds([]);
    }
  };

  return (
    <Modal open={open} onClose={onClose} className={"segmentSelectionModal"}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <Input
          placeholder="Search..."
          value={searchTerm}
          className={"search"}
          onChange={(_, data) => setSearchTerm(data.value)}
        />
        <div className={"tableContainer"}>
          <Table compact>
            <TableHeader>
              <TableRow>
                <TableHeaderCell>
                  <Checkbox
                    checked={selectedIds.length > 0 && selectedIds.length == options.length}
                    onChange={(_, data) => {
                      selectAll(!!data.checked);
                    }}
                  />
                </TableHeaderCell>
                <TableHeaderCell>Name</TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filteredOptions.map((option, index) => {
                return (
                  <TableRow key={`segment-${index}`}>
                    <TableCell collapsing>
                      <Checkbox
                        checked={selectedIds.includes(option.id)}
                        onChange={(_, data) => {
                          if (!data.checked) setSelectedIds(s => s.filter(o => o != option.id));
                          else if (!selectedIds.includes(option.id)) setSelectedIds(s => [...s, option.id]);
                        }}
                      />
                    </TableCell>
                    <TableCell>{option.name}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button type="button" onClick={onClose} secondary>
          Close
        </Button>

        <Button type="button" onClick={() => onUpdate(selectedIds)} primary>
          Done
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export const SegmentSelectionModal = SegmentSelectionModalFC;
